export const pathNames = {
    Home: "HOME",
    products: "SHOP",
};

export const pathRoutes = {
    products: "products",
};
